import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import GenericModel from 'js/models/generic.model';

    export default GenericModel.extend({
        defaults: {
            submissionDate: '',
            type: '',
            importedContacts: 0,
            valid: 0,
            duplicates: 0,
            erroneous: 0,
            newContacts: 0,
            exceeding: 0,
            parsingPartitionNumber: 0,
            parsingTotalPartitions: 0,
            partitionNumber: 0,
            totalPartitions: 0,
            totalContacts: 0
        }
    });
